import { Container, colors } from 'component-library';

export const BoxContainer = ({ children }: { children: React.ReactNode }) => (
  <Container outline={true} outlineColor={colors.monochrome.grey20} p="mediumLow">
    {children}
  </Container>
);
